<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>HPP</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th width="50">No</th>
                  <th width="50"></th>
                  <th width="100">Code</th>
                  <th width="200">Nama Barang</th>
                  <th width="100">Awal</th>
                  <th width="100">Beli</th>
                  <th width="100">Pakai</th>
                  <th width="100">Rusak</th>
                  <th width="100">Hilang</th>
                  <th width="100">Akhir</th>
                </tr>
              </thead>
              <tbody v-for="(v, k) in data.data" :key="k">
                <tr>
                  <td rowspan="3" class="text-center text-middle">
                    <table-number-2 :paginate="data.paginate" :index="k" />
                  </td>
                  <td>QTY</td>
                  <td rowspan="3" class="text-center text-middle">
                    {{ v.code }}
                  </td>
                  <td rowspan="3" class="text-left text-middle">
                    {{ v.name }}
                  </td>
                  <td class="text-right">{{ v.last_month.qty }}</td>
                  <td class="text-right">{{ v.buy.qty }}</td>
                  <td class="text-right">{{ v.use.qty }}</td>
                  <td class="text-right">{{ v.broken.qty }}</td>
                  <td class="text-right">{{ v.lost.qty }}</td>
                  <td class="text-right">{{ v.current.qty }}</td>
                </tr>
                <tr>
                  <td>U/P</td>
                  <td class="text-right">{{ v.last_month.up }}</td>
                  <td class="text-right">{{ v.buy.up }}</td>
                  <td class="text-right">{{ v.use.up }}</td>
                  <td class="text-right">{{ v.broken.up }}</td>
                  <td class="text-right">{{ v.lost.up }}</td>
                  <td class="text-right">{{ v.current.up }}</td>
                </tr>
                <tr>
                  <td>Rp</td>
                  <td class="text-right">
                    {{ v.last_month.rp | thousandSeparator }}
                  </td>
                  <td class="text-right">{{ v.buy.rp | thousandSeparator }}</td>
                  <td class="text-right">{{ v.use.rp | thousandSeparator }}</td>
                  <td class="text-right">
                    {{ v.broken.rp | thousandSeparator }}
                  </td>
                  <td class="text-right">
                    {{ v.lost.rp | thousandSeparator }}
                  </td>
                  <td class="text-right">
                    {{ v.current.rp | thousandSeparator }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <paginator :paginator="data.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import Paginator from '../../components/Paginator.vue'
import TableNumber2 from '../../components/TableNumber2.vue'
import { HTTPAUTH } from '../../lib/httplib'
export default {
  data () {
    return {
      data: {}
    }
  },
  components: { Paginator, TableNumber2 },
  created () {
    this.getList(1)
  },
  methods: {
    changePage (page) {
      this.getList(page)
    },
    getList (page) {
      HTTPAUTH.get(`/api/v1/income-statement/hpp?page=${page}&size=6`).then(res => {
        this.data = res.data
        this.$router.push({ query: { page: page } })
      })
    }
  }
}
</script>